import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import moment from "moment";
import { momentLocaleOf } from "./utils/momentLocale";

import en from "./i18n/locales/en/translations.json";
import fr from "./i18n/locales/fr/translations.json";

import clientViewTranslationEn from "./i18n/locales/en/clientViewTranslation.json";
import clientViewTranslationFr from "./i18n/locales/fr/clientViewTranslation.json";
import clientViewTranslationDe from "./i18n/locales/de/clientViewTranslation.json";
import clientViewTranslationIt from "./i18n/locales/it/clientViewTranslation.json";
import clientViewTranslationEs from "./i18n/locales/es/clientViewTranslation.json";
import clientViewTranslationAr from "./i18n/locales/ar/clientViewTranslation.json";
import clientViewTranslationZh from "./i18n/locales/zh/clientViewTranslation.json";
import clientViewTranslationPt from "./i18n/locales/pt/clientViewTranslation.json";
import clientViewTranslationRu from "./i18n/locales/ru/clientViewTranslation.json";
import clientViewTranslationJa from "./i18n/locales/ja/clientViewTranslation.json";

export const SUPPORTED_LNGS = [
  "en",
  "en-US",
  "en-EU",
  "en-CH",
  "fr",
  "fr-FR",
  "fr-CH",
  "de",
  "de-DE",
  "de-CH",
  "it",
  "it-IT",
  "it-CH",
  "es",
  "es-ES",
  "es-MX",
  "ar",
  "ar-SA",
  "ar-AE",
  "zh",
  "zh-CN",
  "zh-TW",
  "pt",
  "pt-BR",
  "pt-PT",
  "ru",
  "ru-RU",
  "ja",
  "ja-JP",
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en,
        clientView: clientViewTranslationEn,
      },
      "en-US": {
        translation: en,
        clientView: clientViewTranslationEn,
      },
      "en-EU": {
        translation: en,
        clientView: clientViewTranslationEn,
      },
      "en-CH": {
        translation: en,
        clientView: clientViewTranslationEn,
      },
      fr: {
        translation: fr,
        clientView: clientViewTranslationFr,
      },
      "fr-FR": {
        translation: fr,
        clientView: clientViewTranslationFr,
      },
      "fr-CH": {
        translation: fr,
        clientView: clientViewTranslationFr,
      },
      de: {
        translation: en,
        clientView: clientViewTranslationDe,
      },
      "de-DE": {
        translation: en,
        clientView: clientViewTranslationDe,
      },
      "de-CH": {
        translation: en,
        clientView: clientViewTranslationDe,
      },
      it: {
        translation: en,
        clientView: clientViewTranslationIt,
      },
      "it-IT": {
        translation: en,
        clientView: clientViewTranslationIt,
      },
      "it-CH": {
        translation: en,
        clientView: clientViewTranslationIt,
      },
      es: {
        translation: en,
        clientView: clientViewTranslationEs,
      },
      "es-ES": {
        translation: en,
        clientView: clientViewTranslationEs,
      },
      "es-MX": {
        translation: en,
        clientView: clientViewTranslationEs,
      },
      ar: {
        translation: en,
        clientView: clientViewTranslationAr,
      },
      "ar-SA": {
        translation: en,
        clientView: clientViewTranslationAr,
      },
      "ar-AE": {
        translation: en,
        clientView: clientViewTranslationAr,
      },
      zh: {
        translation: en,
        clientView: clientViewTranslationZh,
      },
      "zh-CN": {
        translation: en,
        clientView: clientViewTranslationZh,
      },
      "zh-TW": {
        translation: en,
        clientView: clientViewTranslationZh,
      },
      pt: {
        translation: en,
        clientView: clientViewTranslationPt,
      },
      "pt-BR": {
        translation: en,
        clientView: clientViewTranslationPt,
      },
      "pt-PT": {
        translation: en,
        clientView: clientViewTranslationPt,
      },
      ru: {
        translation: en,
        clientView: clientViewTranslationRu,
      },
      "ru-RU": {
        translation: en,
        clientView: clientViewTranslationRu,
      },
      ja: {
        translation: en,
        clientView: clientViewTranslationJa,
      },
      "ja-JP": {
        translation: en,
        clientView: clientViewTranslationJa,
      },
    },
    fallbackLng: "en-US",
    debug: false,
    supportedLngs: SUPPORTED_LNGS,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["querystring", "cookie", "localStorage", "navigator"],
      caches: ["cookie", "localStorage"],
      lookupQuerystring: "language",
      lookupCookie: "NEXT_LOCALE",
      lookupLocalStorage: "NEXT_LOCALE",
      cookieOptions: {
        path: "/",
        domain:
          window.location.hostname.split(".").length > 2
            ? "." +
              window.location.hostname
                .split(".")
                .slice(
                  window.location.hostname.split(".").length - 2,
                  window.location.hostname.split(".").length
                )
                .join(".")
            : "." + window.location.hostname,
        secure: window.location.protocol === "https:",
        sameSite: "none",
        maxAge: 60 * 60 * 24 * 365,
      },
    },
    react: {
      useSuspense: false,
    },
  });

const appliquerLangue = (langue: string) => {
  moment.locale(momentLocaleOf(langue));
  document.documentElement.lang = langue || "en";
};

appliquerLangue(i18n.language);
i18n.on("languageChanged", appliquerLangue);

export default i18n;
